import { useContext } from 'react';

import { ReservationLocalstorageSteps } from 'modules/accommodations/features/reservations/components/ReservationAddNew/ReservationSteps/consts';
import { localStorageValuesFromFirstStep } from 'modules/accommodations/features/reservations/helper';
import { useTransitionInStepsTransformedTableData } from 'modules/accommodations/features/reservations/hooks';
import { ReservationNewContext } from 'modules/accommodations/features/reservations/routes/ReservationNewContext';

export const useInitialValuesServiceTransformData = (rowIndex: number) => {
  const { thirdStepTableState } = useContext(ReservationNewContext);
  const { servicesTableData, discountsTableData, isServiceSideBarOpen } = thirdStepTableState;

  const localstorageFirstStep = JSON.parse(
    localStorage.getItem(ReservationLocalstorageSteps.FIRSTSTEP) as string,
  );
  const { from, to, numberOfGuestsSum, adultsNumber, babiesNumber, childrenNumber, teensNumber } =
    localStorageValuesFromFirstStep(localstorageFirstStep);

  const { transformedServicesDataForAPI } = useTransitionInStepsTransformedTableData(
    servicesTableData,
    discountsTableData,
    from,
    to,
    numberOfGuestsSum,
    isServiceSideBarOpen,
    null,
    adultsNumber,
    babiesNumber,
    childrenNumber,
    teensNumber,
  );

  //initial values
  if (!transformedServicesDataForAPI[rowIndex]) {
    return {
      serviceId: '',
      unitOfMeasureId: '',
      dateFrom: from,
      dateTo: to,
      sellingPricePerUnitOfMeasure: '',
      purchasePricePerUnitOfMeasure: '',
      amount: '',
      numberOfGuests: numberOfGuestsSum,
      adults: adultsNumber,
      babies: babiesNumber,
      children: childrenNumber,
      teens: teensNumber,
    };
  }

  return transformedServicesDataForAPI[rowIndex];
};
